var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"php-code-editor-wrap",style:({ height: _vm.height })},[_c('textarea',{ref:"textarea",staticClass:"php-code-textarea-fallback"})])}
var staticRenderFns = []

export { render, staticRenderFns }